import React, { useState, useEffect } from "react";
import { Tab, Tabs } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom"; 
import TabPanel from "../../components/common/tabpannel/Tabpannel";
import ClassSchedulesTab from "./classschedules/ClassScheduletab";
import ExtraClassesTab from "./extraclasses/Extraclassestab";
import StudyGroupTab from "./studygroup/Studygroup";


const OrganizeClasses = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate(); 
  const location = useLocation(); 

  useEffect(() => {
    if (location.pathname === "/organizeclasses/classschedules") {
      setSelectedTab(0);
    } else if (location.pathname === "/organizeclasses/studygroup") {
      setSelectedTab(1);
    } else if (location.pathname === "/organizeclasses/extraclasses") {
      setSelectedTab(2);
    }
  }, [location.pathname]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);

    if (newValue === 0) {
      navigate("/organizeclasses/classschedules");
    }  else if (newValue === 1) {
      navigate("/organizeclasses/studygroup");
    } else if (newValue === 2) {
      navigate("/organizeclasses/extraclasses");
    } 
  };

  return (
    <div>
      <div className="p-5">
        <TabPanel value={selectedTab} index={0}>
          <ClassSchedulesTab /> .
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
          <StudyGroupTab />
        </TabPanel>
        <TabPanel value={selectedTab} index={2}>
          <ExtraClassesTab />
        </TabPanel>
      </div>
    </div>
  );
};

export default OrganizeClasses;
